import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ExitModal from "./ExitModal";
import { postClose } from "../../../../utils/utilPostMessage";

const ExitModalContainer = ({ isExitModalOpen, setIsExitModalOpen, onSave }) => {
  const { externalOverlay } = useSelector((state) => state.info);

  useEffect(() => {
    if (externalOverlay) {
      const handleMessage = async (event) => {
        const data = event.data;
        if (data.type === "overlay-to-snippet") {
          const extra = data.extra;
          if (extra.id === "exit-modal" && extra.action === "exit") {
            var saveSuccess = true;
            if (extra.save) {
              saveSuccess = await onSave();
            }

            postClose(saveSuccess);
          }
        }
      };

      window.addEventListener("message", handleMessage);
      return () => {
        window.removeEventListener("message", handleMessage);
      };
    }
  }, [externalOverlay, onSave]);

  return (
    !externalOverlay &&
    isExitModalOpen && (
      <ExitModal
        onExitWithoutSaving={() => {}}
        onExitWithSaving={() => {}}
        onCancel={() => setIsExitModalOpen(false)}
        dataFromSnippet={{
          headerTitle: "Leave page without saving?",
          bodyMessage: "You have unsaved changes. Are you sure you want to leave this page?",
          cancelText: "Cancel",
          exitWithoutSaving: "Exit without saving",
          exitWithSaving: "Save and exit",
        }}
      />
    )
  );
};

export default ExitModalContainer;
